import React, { useEffect } from "react";
import "mapbox-gl/dist/mapbox-gl.css";
import LayersIcon from '@mui/icons-material/Layers';
import LocalFloristIcon from '@mui/icons-material/LocalFlorist';
import { handleGeneratePdf } from "./Report/GenerateReport";

import DataSnackbar from "./DataSnackbar"; 

// For Map component
import MapDisplay from "./Map/MapDisplay";
import { useMapContext } from "./Map/MapContext";

// For Map Control Panel component
import { getColorLayer, getOutfallColor } from "./MapControlPanel/getColorFunctions";
import MapControlPanel from "./MapControlPanel/MapControlPanel";

// For Map Layer component
import { useMapLayer } from "./MapLayers/useMapLayer";
import MapLayer from "./MapLayers/MapLayer";

import FloodIcon from '@mui/icons-material/Flood';
import SimpleIcon from "./Utils/IconButton";
import GraphPanel from "./GraphPanel/GraphPanel";
import LIDPanel from "./LIDPanel/LIDPanel";
import SystemTotalsPanel from './SystemTotalsPanel';

// function MapComponent(userData) {
function MapComponent() {
    const {
        // stormMode,
        LIDMode,
        // mapClickInfo,
        selectedFeature,
        setGeoJSONData,
        selectedStormOption,
        fetchTimeseriesData,
        fetchRainfallData,
        // handleStormMode,
        handleLIDMode,
        LIDContent,
        devPlanContent,
        userData,

        floodingVisual,
        setFloodingVisual,

    } = useMapContext();

    const { colorScheme, layersVisible, handleColorSchemeChange, handleToggleLayers } = useMapLayer();

    // Load the GeoJSON data from the server 
    useEffect(() => {
        fetch('/map_layers/updated_subcatchments.geojson')
            .then(response => response.json())
            .then(data => setGeoJSONData(prevData => ({...prevData, subcatchments: data})))
            .catch(error => console.error('Error loading GeoJSON:', error));
        fetch('/map_layers/CleanOutfalls.geojson')
            .then(response => response.json())
            .then(data => setGeoJSONData(prevData => ({...prevData, outfalls: data})))
            .catch(error => console.error('Error loading GeoJSON:', error));
        fetch('/map_layers/Mar27_Overflows.json')
            .then(response => response.json())
            .then(data => setGeoJSONData(prevData => ({...prevData, overflowData: data})))
            .catch(error => console.error('Error loading Overflow JSON:', error));
    }, []);

    useEffect(() => {
        fetch(`/map_layers/${selectedStormOption}_Overflows.json`)
            .then(response => response.json())
            .then(data => setGeoJSONData(prevData => ({...prevData, overflowData: data})))
            .catch(error => console.error('Error loading Overflow JSON:', error));
    }, [selectedStormOption]);

    // Preload data for a default subcatchment
    useEffect(() => {
        const preloadData = async () => {
            try {
                // Choose a default subcatchment ID
                const defaultSubcatchmentId = 'WRRF_001'; // Replace with an actual subcatchment ID
                await fetchTimeseriesData('subcatchment', defaultSubcatchmentId, 'runoff', selectedStormOption);
                await fetchRainfallData(defaultSubcatchmentId, selectedStormOption);
                console.log('Preloaded data for default subcatchment');
            } catch (error) {
                console.error('Error preloading data:', error);
            }
        };

        preloadData();
    }, []);

    const handleFloodingVisual = async () => {
        setFloodingVisual(!floodingVisual);
        const url = "https://tycoon-bucket162046-main.s3.us-east-2.amazonaws.com/public/Detroit/geojsons2018/Junctions.geojson";

        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            const sizeInBytes = new TextEncoder().encode(JSON.stringify(data)).length;
            console.log(`GeoJSON file size: ${sizeInBytes} bytes`);
        } catch (error) {
            console.error('Error fetching or processing GeoJSON file:', error);
        }
    };


    return (
        <div className="map-container">
                <SimpleIcon 
                    title="Explore Map Layers" sx={{position: 'absolute', top: 10, left: 10, zIndex: 1000}}
                    onClick={handleToggleLayers} colorState={layersVisible} IconComponent={LayersIcon}
                />

                <SimpleIcon 
                    title="Add Green Infrastructure" sx={{position: 'absolute', top: 50, left: 10, zIndex: 1000}}
                    onClick={handleLIDMode} colorState={LIDMode} IconComponent={LocalFloristIcon}
                />

                <SimpleIcon 
                    title="Visualize Flooding" sx={{position: 'absolute', top: 90, left: 10, zIndex: 1000}}
                    onClick={handleFloodingVisual} colorState={floodingVisual} IconComponent={FloodIcon}
                />

                <MapLayer
                    {...{
                        layersVisible,
                        colorScheme,
                        handleColorSchemeChange
                    }}
                />

                <GraphPanel />
                <SystemTotalsPanel />
                <LIDPanel userData={userData} />

                <MapDisplay>
                    <MapControlPanel
                        getColorLayer={() => getColorLayer(colorScheme, selectedFeature.ID, LIDMode, LIDContent, devPlanContent)}
                        getOutfallColor={getOutfallColor}
                    />
                </MapDisplay>

                {selectedFeature.Data && (
                    <DataSnackbar selectedFeatureData={selectedFeature.Data}/>
                )}
        </div>
    );
}

export default MapComponent;
